/**
 * Title: Action Types for Critical Process
 * Description: Action Types for Critical Process
 * Author: Iqbal Hossain
 * Date: 10-January-2022
 * Modified: 10-January-2022
 **/

export const FETCH_CRITICAL_PROCESS = 'FETCH_CRITICAL_PROCESS';
export const TOGGLE_CRITICAL_PROCESS_SIDEBAR = 'TOGGLE_CRITICAL_PROCESS_SIDEBAR';
export const TOGGLE_CRITICAL_PROCESS_STATUS = 'TOGGLE_CRITICAL_PROCESS_STATUS';
export const FETCH_CRITICAL_PROCESS_BY_QUERY = 'FETCH_CRITICAL_PROCESS_BY_QUERY';
export const ADD_CRITICAL_PROCESS = 'ADD_CRITICAL_PROCESS';
export const DELETE_CRITICAL_PROCESS = 'DELETE_CRITICAL_PROCESS';
export const FETCH_CRITICAL_PROCESS_BY_ID = 'FETCH_CRITICAL_PROCESS_BY_ID';
export const UPDATE_CRITICAL_PROCESS = 'UPDATE_CRITICAL_PROCESS';
export const DELETE_CRITICAL_PROCESS_BY_RANGE = 'DELETE_CRITICAL_PROCESS_BY_RANGE';
